import { BrandingHiddenSections } from '../main/constants/BrandingHiddenSections';
export interface IBrandingPayload {
    id: string;
    primaryColor: string;
    primaryLogo: string;
    secondaryLogo: string;
    tertiaryLogo: string;
    hiddenSections: BrandingHiddenSections[];
}

export class Branding {
    private readonly _id: string;
    private readonly _primaryLogo: string;
    private readonly _secondaryLogo: string;
    private readonly _tertiaryLogo: string;
    private readonly _primaryColor: string;
    private readonly _hiddenSections: BrandingHiddenSections[];

    constructor(branding: IBrandingPayload) {
        this._id = branding.id;
        this._primaryColor = branding.primaryColor;
        this._primaryLogo = branding.primaryLogo;
        this._secondaryLogo = branding.secondaryLogo;
        this._tertiaryLogo = branding.tertiaryLogo;
        this._hiddenSections = branding.hiddenSections;
    }

    get id(): string {
        return this._id;
    }

    get primaryLogo(): string {
        return this._primaryLogo;
    }

    get secondaryLogo(): string {
        return this._secondaryLogo;
    }

    get tertiaryLogo(): string {
        return this._tertiaryLogo;
    }

    get primaryColor(): string {
        return this._primaryColor;
    }

    get hiddenSections(): BrandingHiddenSections[] {
        return this._hiddenSections;
    }
}
